import { InputField } from '../../shared/models';

export interface HotelInformation {
    numberOfRooms: InputField<number | null>;
}
